import { render, staticRenderFns } from "./OsobaUmanjeniSatBase.vue?vue&type=template&id=c1d79a10&scoped=true&"
import script from "./OsobaUmanjeniSatBase.vue?vue&type=script&lang=js&"
export * from "./OsobaUmanjeniSatBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d79a10",
  null
  
)

export default component.exports